// extracted by mini-css-extract-plugin
export var content = "_nc-1";
export var fullScreen = "_nc-0";